import type { FormationId } from "../types/leagueDuel";

// ─── Config des compositions ──────────────────────────────────────────────────
// Modifie ici les compos disponibles et leur biais offensif/défensif.
// `attackBias` : 0 = très défensif, 1 = très offensif (utilisé par la sim pour
// pondérer les chances de créer une occasion). Reste léger, pas d'équilibrage fin.

export interface FormationDef {
  id: FormationId;
  label: string;
  description: string;
  attackBias: number; // 0..1
  // Répartition visuelle des 5 joueurs : nb en défense / attaque (le gardien est implicite).
  defenders: number;
  attackers: number;
}

export const FORMATIONS: FormationDef[] = [
  {
    id: "3-1",
    label: "3-1",
    description: "Defensive",
    attackBias: 0.3,
    defenders: 3,
    attackers: 1,
  },
  {
    id: "2-2",
    label: "2-2",
    description: "Balanced",
    attackBias: 0.5,
    defenders: 2,
    attackers: 2,
  },
  {
    id: "1-3",
    label: "1-3",
    description: "Offensive",
    attackBias: 0.7,
    defenders: 1,
    attackers: 3,
  },
];

export const FORMATION_BY_ID: Record<FormationId, FormationDef> = FORMATIONS.reduce(
  (acc, f) => ((acc[f.id] = f), acc),
  {} as Record<FormationId, FormationDef>
);

export const DEFAULT_FORMATION: FormationId = "2-2";
